module.exports = function (runtimeConfiguration) {
	var imageryConfig = {};

	if (runtimeConfiguration && runtimeConfiguration.imagery) {
		imageryConfig = runtimeConfiguration.imagery;
	}

	return imageryConfig;
};
